import { useEffect } from 'react';
import styled from 'styled-components';
import { useThumbnailManualReady } from '@elfsight/configurator-preview';
import { Deactivation } from '@elfsight/widget-deactivation';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import { meta } from '../../constants';
import { WidgetHeader } from '../header';
import { Layout } from '../layout';
import { Popup } from '../popup';
import { useSocialFeedSettings } from '../utils';
import { WidgetBackground } from './WidgetBackground';
import { WidgetError } from './WidgetError';
import { WidgetTitle } from './WidgetTitle';

export function Main() {
  const {
    font,
    widgetWidth,
    displayDeactivation,
    deactivationURL,
    renderThumbnailMode,
    ...settings
  } = useSocialFeedSettings();

  const freeLinkSettings = pickFreeLinkSettings(settings);

  const [enableThumbnailReadyListener, resolveThumbnailReadyListener] =
    useThumbnailManualReady(renderThumbnailMode);

  useEffect(() => {
    enableThumbnailReadyListener();
  }, [enableThumbnailReadyListener]);

  return (
    <>
      <Inner
        _font={font?.value}
        onLoad={() => resolveThumbnailReadyListener()} // Короткая запись onLoad={resolveThumbnailReadyListener} не работает по неустановленным причинам
      >
        <WidgetBackground>
          <WidgetTitle />

          <WidgetHeader />

          <WidgetError />

          <Layout />

          <FreeLink
            {...freeLinkSettings}
            appAlias={meta.alias}
            appName={meta.name}
            style={{ link: { marginTop: '20px' } }}
          />

          <Deactivation
            displayDeactivation={displayDeactivation}
            deactivationURL={deactivationURL}
            appAlias={meta.alias}
          />
        </WidgetBackground>
      </Inner>

      <Popup />
    </>
  );
}

const Inner = styled.div<{
  _font?: string;
}>`
  & div:empty {
    display: block !important;
  }

  ${({ _font }) => !!_font && `font-family: "${_font}"`};
`;
